import { createAsyncThunk } from "@reduxjs/toolkit";
import { highlightConfigAPIs } from "services/api/core/highlightConfigAPIs";
import { handleApiError } from "utils/errorHandler";

export const createHighlightConfig = createAsyncThunk("highlightConfig/createHighlightConfig", async (payload) => {
  try {
    const response = await highlightConfigAPIs.createHighlightConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const deleteHighlightConfig = createAsyncThunk("highlightConfig/deleteHighlightConfig", async (payload) => {
  try {
    const response = await highlightConfigAPIs.deleteHighlightConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const getHighlightConfigs = createAsyncThunk("highlightConfig/getHighlightConfigs", async (payload) => {
  try {
    const response = await highlightConfigAPIs.getHighlightConfigs(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const createHighlightType = createAsyncThunk("highlightConfig/createHighlightType", async (payload) => {
  try {
    const response = await highlightConfigAPIs.createHighlightType(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw handleApiError(error);
  }
});

export const getHighlightTypes = createAsyncThunk("highlightConfig/getHighlightTypes", async (payload) => {
  try {
    const response = await highlightConfigAPIs.getHighlightTypes(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const updateHighlightType = createAsyncThunk("highlightConfig/updateHighlightType", async (payload) => {
  try {
    const response = await highlightConfigAPIs.updateHighlightType(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});

export const deleteHighlightType = createAsyncThunk("highlightConfig/deleteHighlightType", async (payload) => {
  try {
    const response = await highlightConfigAPIs.deleteHighlightType(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error?.response?.data?.error || error;
  }
});
